import { useInfiniteQuery } from '@tanstack/react-query'

import { fetchVenueRevenue } from '@/lib/venue/revenueApi'
import type { RevenueListFilter } from '@/lib/venue/revenueViewModel'

export function revenueQueryKey(venueId: string, filter: RevenueListFilter) {
  return ['venue', venueId, 'revenues', filter] as const
}

/**
 * 🚨 `useVenueReservations.ts`와 동일한 이유로 `getNextPageParam`을 직접 선언한다 — 서버(#792 §2)가
 * `nextCursor`를 이미 인코딩된 불투명 문자열로 응답에 직접 내려준다(`lib/api/cursor.ts` 패턴과 다르다).
 */
export function useVenueRevenue(venueId: string, filter: RevenueListFilter) {
  return useInfiniteQuery({
    queryKey: revenueQueryKey(venueId, filter),
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      fetchVenueRevenue(venueId, filter, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.nextExist ? (lastPage.nextCursor ?? undefined) : undefined),
  })
}
